module.exports = __webpack_public_path__ + "img/esp-sertifikat-1.2f94043b.jpg";